export const GET_ALL_FAQS = "GET_ALL_FAQS";
export const GET_EDIT_DATA = "GET_EDIT_DATA";
export const GET_INSERTBID_CONTENT = "GET_INSERTBID_CONTENT";
export const GET_NEWSLETTER_CONTENT = "GET_NEWSLETTER_CONTENT";
export const GET_BUYING_CONTENT = "GET_BUYING_CONTENT";
export const GET_SELLING_CONTENT = "GET_SELLING_CONTENT";
export const GET_FINALIZE_CONTENT = "GET_FINALIZE_CONTENT";
export const GET_CONTACT_US_CONTENT = "GET_CONTACT_US_CONTENT";
export const GET_SELL_ITEM_CONTENT = "GET_SELL_ITEM_CONTENT";
export const GET_PHOTO_GUIDE_CONTENT = "GET_PHOTO_GUIDE_CONTENT";
export const GET_COLLECTIBLES_SHIPPING_CONTENT =
  "GET_COLLECTIBLES_SHIPPING_CONTENT";
export const GET_HEADER_CONTENT = "GET_HEADER_CONTENT";
export const GET_BLOG_SPOTLIGHT_CONTENT = "GET_BLOG_SPOTLIGHT_CONTENT";
